import { getContext } from '@fiverr-private/fiverr_context';

export const BLOCKED_COUNTRIES = [
    'pakistan',
    'india',
    'bangladesh',
    'philippines',
    'indonesia',
    'nigeria',
    'turkey',
    'sri lanka',
    'vietnam',
    'morocco',
    'united arab emirates',
    'malaysia',
    'kenya',
    'nepal',
    'tunisia',
];

export const canViewBusinessLink = () => {
    const { country } = getContext();
    return country && !BLOCKED_COUNTRIES.includes(country.toLowerCase());
};
